// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-page {
  width: 100%;
  min-height: 100vh;
  background: #121212;
  color: #F1F1F1;
  font-family: 'Satoshi', sans-serif;
}

/* ================================
   Hero Section
================================ */
.about-hero {
  position: relative;
  width: 100%;
  height: 60vh;
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
}

.about-hero-video-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.about-hero-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.about-hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(18, 18, 18, 0.85) 0%,
    rgba(18, 18, 18, 0.6) 50%,
    rgba(18, 18, 18, 0.3) 100%
  );
  z-index: 1;
}

.about-hero-breadcrumbs {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 3;
  padding: 3vw 5vw 0;
}

.about-hero-content {
  position: relative;
  z-index: 2;
  padding: 0 60px;
  max-width: 1200px;
  width: 100%;
}

.about-hero-title {
  font-size: 5vw;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.03em;
  margin: 0 0 24px 0;
  color: #F1F1F1;
}

.about-hero-mission {
  font-size: 1.5vw;
  font-weight: 400;
  line-height: 1.6;
  max-width: 600px;
  color: #F1F1F1;
  margin: 0;
}

/* ================================
   Our Story Section
================================ */
.about-story {
  padding: 100px 60px;
  background: #121212;
}

.about-story-container {
  max-width: 1200px;
  margin: 0 auto;
}

.about-story-title {
  font-size: 4vw;
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: -0.03em;
  text-align: center;
  margin: 0 0 80px 0;
  color: #F1F1F1;
}

.about-story-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 60px;
  padding: 0;
}

.about-story-column {
  padding: 0;
}

.about-story-column-title {
  font-size: 1.5vw;
  font-weight: 500;
  line-height: 1.4;
  margin: 0 0 24px 0;
  color: #F1F1F1;
}

.about-story-column-text {
  font-size: 1.1vw;
  font-weight: 400;
  line-height: 1.8;
  margin: 0 0 20px 0;
  color: rgba(241, 241, 241, 0.6);
}

.about-story-column-text:last-child {
  margin-bottom: 0;
}

.about-story-column-text strong {
  color: #CCFF00;
  font-weight: 600;
}

/* ================================
   What We Do Section
================================ */
.about-what-we-do {
  padding: 100px 60px;
  background: #121212;
}

.about-what-we-do-container {
  max-width: 1200px;
  margin: 0 auto;
}

.about-what-we-do-title {
  font-size: 4vw;
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: -0.03em;
  text-align: center;
  margin: 0 0 80px 0;
  color: #F1F1F1;
}

.about-what-we-do-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
}

.about-what-we-do-item {
  padding: 32px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.about-what-we-do-item:hover {
  background: rgba(204, 255, 0, 0.1);
  border-color: #CCFF00;
  box-shadow: 0 8px 24px rgba(204, 255, 0, 0.25);
  transform: translateY(-4px);
}

.about-what-we-do-item h3 {
  font-size: 1.3vw;
  font-weight: 500;
  line-height: 1.4;
  margin: 0 0 16px 0;
  color: #F1F1F1;
}

.about-what-we-do-item p {
  font-size: 1vw;
  font-weight: 400;
  line-height: 1.7;
  margin: 0;
  color: rgba(241, 241, 241, 0.6);
}

/* ================================
   Mobile Responsive
================================ */
@media (max-width: 1024px) {
  .about-hero-title {
    font-size: 6vw;
  }

  .about-hero-mission {
    font-size: 2vw;
  }

  .about-story-title {
    font-size: 5vw;
  }

  .about-story-column-title {
    font-size: 2vw;
  }

  .about-story-column-text {
    font-size: 1.5vw;
  }

  .about-what-we-do-title {
    font-size: 5vw;
  }

  .about-what-we-do-item h3 {
    font-size: 1.8vw;
  }

  .about-what-we-do-item p {
    font-size: 1.4vw;
  }
}

@media (max-width: 768px) {
  .about-hero {
    height: 50vh;
    min-height: 400px;
  }

  .about-hero-content {
    padding: 0 20px;
  }

  .about-hero-title {
    font-size: 36px;
    margin-bottom: 16px;
  }

  .about-hero-mission {
    font-size: 18px;
    max-width: 100%;
  }

  .about-story {
    padding: 60px 20px;
  }

  .about-story-title {
    font-size: 32px;
    margin-bottom: 40px;
  }

  .about-story-grid {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .about-story-column-title {
    font-size: 20px;
    margin-bottom: 16px;
  }

  .about-story-column-text {
    font-size: 16px;
    margin-bottom: 16px;
  }

  .about-what-we-do {
    padding: 60px 20px;
  }

  .about-what-we-do-title {
    font-size: 32px;
    margin-bottom: 40px;
  }

  .about-what-we-do-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .about-what-we-do-item {
    padding: 24px;
  }

  .about-what-we-do-item h3 {
    font-size: 18px;
    margin-bottom: 12px;
  }

  .about-what-we-do-item p {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .about-hero {
    height: 40vh;
    min-height: 300px;
  }

  .about-hero-title {
    font-size: 28px;
  }

  .about-hero-mission {
    font-size: 16px;
  }

  .about-story {
    padding: 40px 20px;
  }

  .about-story-title {
    font-size: 28px;
    margin-bottom: 32px;
  }

  .about-story-column-title {
    font-size: 18px;
  }

  .about-story-column-text {
    font-size: 14px;
  }

  .about-what-we-do {
    padding: 40px 20px;
  }

  .about-what-we-do-title {
    font-size: 28px;
    margin-bottom: 32px;
  }

  .about-what-we-do-item {
    padding: 20px;
  }

  .about-what-we-do-item h3 {
    font-size: 16px;
  }

  .about-what-we-do-item p {
    font-size: 13px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/about/about.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kCAAkC;AACpC;;AAEA;;kCAEkC;AAClC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;;kCAEkC;AAClC;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;kCAEkC;AAClC;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,+BAA+B;AACjC;;AAEA;;kCAEkC;AAClC;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".about-page {\n  width: 100%;\n  min-height: 100vh;\n  background: #121212;\n  color: #F1F1F1;\n  font-family: 'Satoshi', sans-serif;\n}\n\n/* ================================\n   Hero Section\n================================ */\n.about-hero {\n  position: relative;\n  width: 100%;\n  height: 60vh;\n  min-height: 500px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  overflow: hidden;\n}\n\n.about-hero-video-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n}\n\n.about-hero-video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.about-hero-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    to right,\n    rgba(18, 18, 18, 0.85) 0%,\n    rgba(18, 18, 18, 0.6) 50%,\n    rgba(18, 18, 18, 0.3) 100%\n  );\n  z-index: 1;\n}\n\n.about-hero-breadcrumbs {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 3;\n  padding: 3vw 5vw 0;\n}\n\n.about-hero-content {\n  position: relative;\n  z-index: 2;\n  padding: 0 60px;\n  max-width: 1200px;\n  width: 100%;\n}\n\n.about-hero-title {\n  font-size: 5vw;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.03em;\n  margin: 0 0 24px 0;\n  color: #F1F1F1;\n}\n\n.about-hero-mission {\n  font-size: 1.5vw;\n  font-weight: 400;\n  line-height: 1.6;\n  max-width: 600px;\n  color: #F1F1F1;\n  margin: 0;\n}\n\n/* ================================\n   Our Story Section\n================================ */\n.about-story {\n  padding: 100px 60px;\n  background: #121212;\n}\n\n.about-story-container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.about-story-title {\n  font-size: 4vw;\n  font-weight: 500;\n  line-height: 1.2;\n  letter-spacing: -0.03em;\n  text-align: center;\n  margin: 0 0 80px 0;\n  color: #F1F1F1;\n}\n\n.about-story-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 60px;\n  padding: 0;\n}\n\n.about-story-column {\n  padding: 0;\n}\n\n.about-story-column-title {\n  font-size: 1.5vw;\n  font-weight: 500;\n  line-height: 1.4;\n  margin: 0 0 24px 0;\n  color: #F1F1F1;\n}\n\n.about-story-column-text {\n  font-size: 1.1vw;\n  font-weight: 400;\n  line-height: 1.8;\n  margin: 0 0 20px 0;\n  color: rgba(241, 241, 241, 0.6);\n}\n\n.about-story-column-text:last-child {\n  margin-bottom: 0;\n}\n\n.about-story-column-text strong {\n  color: #CCFF00;\n  font-weight: 600;\n}\n\n/* ================================\n   What We Do Section\n================================ */\n.about-what-we-do {\n  padding: 100px 60px;\n  background: #121212;\n}\n\n.about-what-we-do-container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.about-what-we-do-title {\n  font-size: 4vw;\n  font-weight: 500;\n  line-height: 1.2;\n  letter-spacing: -0.03em;\n  text-align: center;\n  margin: 0 0 80px 0;\n  color: #F1F1F1;\n}\n\n.about-what-we-do-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 40px;\n}\n\n.about-what-we-do-item {\n  padding: 32px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 16px;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);\n  transition: all 0.3s ease;\n}\n\n.about-what-we-do-item:hover {\n  background: rgba(204, 255, 0, 0.1);\n  border-color: #CCFF00;\n  box-shadow: 0 8px 24px rgba(204, 255, 0, 0.25);\n  transform: translateY(-4px);\n}\n\n.about-what-we-do-item h3 {\n  font-size: 1.3vw;\n  font-weight: 500;\n  line-height: 1.4;\n  margin: 0 0 16px 0;\n  color: #F1F1F1;\n}\n\n.about-what-we-do-item p {\n  font-size: 1vw;\n  font-weight: 400;\n  line-height: 1.7;\n  margin: 0;\n  color: rgba(241, 241, 241, 0.6);\n}\n\n/* ================================\n   Mobile Responsive\n================================ */\n@media (max-width: 1024px) {\n  .about-hero-title {\n    font-size: 6vw;\n  }\n\n  .about-hero-mission {\n    font-size: 2vw;\n  }\n\n  .about-story-title {\n    font-size: 5vw;\n  }\n\n  .about-story-column-title {\n    font-size: 2vw;\n  }\n\n  .about-story-column-text {\n    font-size: 1.5vw;\n  }\n\n  .about-what-we-do-title {\n    font-size: 5vw;\n  }\n\n  .about-what-we-do-item h3 {\n    font-size: 1.8vw;\n  }\n\n  .about-what-we-do-item p {\n    font-size: 1.4vw;\n  }\n}\n\n@media (max-width: 768px) {\n  .about-hero {\n    height: 50vh;\n    min-height: 400px;\n  }\n\n  .about-hero-content {\n    padding: 0 20px;\n  }\n\n  .about-hero-title {\n    font-size: 36px;\n    margin-bottom: 16px;\n  }\n\n  .about-hero-mission {\n    font-size: 18px;\n    max-width: 100%;\n  }\n\n  .about-story {\n    padding: 60px 20px;\n  }\n\n  .about-story-title {\n    font-size: 32px;\n    margin-bottom: 40px;\n  }\n\n  .about-story-grid {\n    grid-template-columns: 1fr;\n    gap: 40px;\n  }\n\n  .about-story-column-title {\n    font-size: 20px;\n    margin-bottom: 16px;\n  }\n\n  .about-story-column-text {\n    font-size: 16px;\n    margin-bottom: 16px;\n  }\n\n  .about-what-we-do {\n    padding: 60px 20px;\n  }\n\n  .about-what-we-do-title {\n    font-size: 32px;\n    margin-bottom: 40px;\n  }\n\n  .about-what-we-do-grid {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .about-what-we-do-item {\n    padding: 24px;\n  }\n\n  .about-what-we-do-item h3 {\n    font-size: 18px;\n    margin-bottom: 12px;\n  }\n\n  .about-what-we-do-item p {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .about-hero {\n    height: 40vh;\n    min-height: 300px;\n  }\n\n  .about-hero-title {\n    font-size: 28px;\n  }\n\n  .about-hero-mission {\n    font-size: 16px;\n  }\n\n  .about-story {\n    padding: 40px 20px;\n  }\n\n  .about-story-title {\n    font-size: 28px;\n    margin-bottom: 32px;\n  }\n\n  .about-story-column-title {\n    font-size: 18px;\n  }\n\n  .about-story-column-text {\n    font-size: 14px;\n  }\n\n  .about-what-we-do {\n    padding: 40px 20px;\n  }\n\n  .about-what-we-do-title {\n    font-size: 28px;\n    margin-bottom: 32px;\n  }\n\n  .about-what-we-do-item {\n    padding: 20px;\n  }\n\n  .about-what-we-do-item h3 {\n    font-size: 16px;\n  }\n\n  .about-what-we-do-item p {\n    font-size: 13px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
